import { AxiosError } from "axios";

/**
 * Construit un message descriptif d'une erreur à partir d'un erreur HTTP-AJAX récupérée.
 * @param {any} error
 */
export function getDescriptiveErrorMessage(error: AxiosError) {
  let msg = error.message;
  if (
    error.response &&
    error.response.statusText &&
    error.response.statusText.length > 0
  ) {
    msg += ` - ${error.response.statusText[0].toUpperCase()}${error.response.statusText.substring(
      1
    )}`;
  }
  return msg;
}

export function getWebApiErrorMessage(error: AxiosError): string {
  return error?.response?.data?.error ?? error.message;
}

export default {
  getDescriptiveErrorMessage,
  getWebApiErrorMessage
};
